import React from 'react';
import PercentageInput from './PercentageInput';

export default class DropdownWithPercentage extends React.PureComponent {
    constructor(params) {
        super(params);
        this.state = {
            lef: '1',
            focus: {
                dropdown: false,
                percentage: false
            }
        };
    }

    render() {
        const activity = this.props.activity;
        const onChange = this.props.onChange;
        const options = this.props.options;
        const onFocus = this.props.onFocus;
        const onBlur = this.props.onBlur;

        return <div className={this.hasFocus(this.state.focus) ? 'focused' : 'not-focused'}>
            <select onChange={ event => onChange({ ...activity, value: event.target.value }) } value={activity.value} onFocus={() => this.setFocus('dropdown', true)} onBlur={() => this.setFocus('dropdown', false)}>
                { options.map((option, i) =>
                    <option key={i} value={option.value}>{option.label}</option>
                ) }
            </select> <PercentageInput value={activity.percentage} onChange={ event => onChange({ ...activity, percentage: event.target.value }) } onFocus={() => this.setFocus('percentage', true)} onBlur={() => this.setFocus('percentage', false)} /> %
        </div>;
    }

    setFocus(key, value) {
        this.setState((prevState, props) => {
            const focus = {
                ...prevState.focus,
                [key]: value,
            };
            if (!this.hasFocus(focus) && props.onBlur) {
                props.onBlur();
            }
            if (this.hasFocus(focus) && props.onFocus) {
                props.onFocus();
            }
            return {
                focus: focus
            }
        })
    }

    hasFocus(focus) {
        return Object.keys(focus).reduce((acc, value) => acc || focus[value], false);
    }
}



// WEBPACK FOOTER //
// ./src/HrcsEditor/input/DropdownWithPercentage.js